import React from 'react';

const ContentLoader = ({ text = "Loading..." }) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '200px',
            width: '100%',
            padding: '2rem',
            textAlign: 'center'
        }}>
            <style>
                {`
                    @keyframes loader-pulse {
                        0% { transform: scale(0.9); opacity: 0.3; }
                        50% { transform: scale(1.1); opacity: 1; }
                        100% { transform: scale(0.9); opacity: 0.3; }
                    }
                `}
            </style>

            {/* Pulsing Circle */}
            <div style={{
                width: '40px',
                height: '40px',
                backgroundColor: '#3b82f6', // RIS Blue
                borderRadius: '50%',
                marginBottom: '1.5rem',
                animation: 'loader-pulse 1.5s infinite ease-in-out',
                boxShadow: '0 0 20px rgba(59, 130, 246, 0.4)'
            }}></div>

            {/* Loading Text */}
            <div style={{
                color: '#64748b',
                fontSize: '0.9rem',
                fontWeight: 500,
                letterSpacing: '0.05em',
                textTransform: 'uppercase'
            }}>
                {text}
            </div>
        </div>
    );
};

export default ContentLoader;
